import { userResource } from '@/services/okFormResource'

export const state = () => ({
  userInfo: {},
})

export const getters = {
  name(state) {
    const { userInfo } = state
    return `${userInfo.givenName} ${userInfo.surname}`
  },
  roles(state) {
    const { userInfo } = state
    return userInfo.roles
  },

  isAuthenticated(state) {
    return !!state.userInfo.isAuthenticated
  },
  canCreate(state) {
    return !!state.userInfo.canCreate
  },
  userAuth(state, getters) {
    return {
      isAuthenticated: getters.isAuthenticated,
      canCreate: getters.canCreate,
    }
  },
}

export const mutations = {
  userInfo(state, userInfo) {
    state.userInfo = userInfo
  },
}

export const actions = {
  async fetchUserInfo({ getters, commit }, { force } = {}) {
    if (!force && getters.isAuthenticated) return getters.userAuth

    try {
      const userInfo = await userResource.fetchInfo()
      commit('userInfo', userInfo)
    } catch (err) {
      console.error('user info failed to load', err)
    }

    return getters.userAuth
  },
}
